<template>
  <div
    id="calendar-header"
    data-fc-render-id="0"
    class="fc fc-media-screen fc-direction-ltr fc-theme-standard"
  >
    <div class="fc-header-toolbar fc-toolbar fc-toolbar-ltr">
      <div class="fc-toolbar-chunk">
        <button
          class="fc-prev-button fc-button fc-button-primary"
          type="button"
          aria-label="prev"
          @click="$emit('previous')"
        >
          <i class="far fa-long-arrow-left"></i>
        </button>
        <button
          class="fc-next-button fc-button fc-button-primary"
          type="button"
          aria-label="next"
          @click="$emit('next')"
        >
          <i class="far fa-long-arrow-right"></i>
        </button>
        <h2 class="fc-toolbar-title">{{ currentMonth }}</h2>
      </div>
      <div class="fc-toolbar-chunk d-none d-md-block">
        <v-select
          class="event-type-select"
          :placeholder="$t('EVENTS.LABEL.FILTER_ALL_TYPES')"
          :options="eventTypes"
          v-model="selectedEventType"
          :on-change="$emit('rerender')"
        />
      </div>
      <div class="fc-toolbar-chunk d-none d-md-block">
        <div class="fc-button-group">
          <button
            class="fc-dayGridMonth-button fc-button fc-button-primary"
            :class="{ 'fc-button-active': currentViewType == 'dayGridMonth' }"
            type="button"
            @click="$emit('changeView', 'dayGridMonth')"
          >
            {{ $t('REPORTS.FILTERS.MONTH') }}
          </button>
          <button
            class="fc-timeGridWeek-button fc-button fc-button-primary"
            :class="{ 'fc-button-active': currentViewType == 'timeGridWeek' }"
            type="button"
            @click="$emit('changeView', 'timeGridWeek')"
          >
            {{ $t('REPORTS.FILTERS.WEEK') }}
          </button>
          <button
            class="fc-timeGridDay-button fc-button fc-button-primary"
            :class="{ 'fc-button-active': currentViewType == 'timeGridDay' }"
            type="button"
            @click="$emit('changeView', 'timeGridDay')"
          >
            {{ $t('REPORTS.FILTERS.DAY') }}
          </button>
          <button
            class="fc-timeGridDay-button fc-button fc-button-primary"
            :class="{ 'fc-button-active': currentViewType == 'listMonth' }"
            type="button"
            @click="$emit('changeView', 'listMonth')"
          >
            {{ $t('GENERAL.LABEL.LIST_VIEW') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CalendarCustomHeader',
  props: {
    currentMonth: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentViewType: 'event/currentViewType',
    }),
    selectedEventType: {
      get() {
        return this.$store.state.event.selectedEventType;
      },
      set(value) {
        this.$store.commit('event/SET_SELECTED_EVENT_TYPE', value);
      },
    },
  },
  data() {
    return {
      eventTypes: [
        {
          label: this.$t('EVENTS.LABEL.FILTER_ALL_TYPES'),
          code: null,
        },
        {
          label: this.$t('EVENTS.LABEL.FILTER_TYPE_BROADCAST'),
          code: 'broadcasting_event',
        },
        {
          label: this.$t('EVENTS.LABEL.FILTER_TYPE_COLLABORATIVE'),
          code: 'collaborative_group_event',
        },
        {
          label: this.$t('EVENTS.LABEL.FILTER_TYPE_PRIVATE'),
          code: 'private_session',
        },
        {
          label: this.$t('EVENTS.LABEL.FILTER_TYPE_LOCAL'),
          code: 'studio_event',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';

#calendar-header {
  .fc-toolbar-chunk {
    display: flex;
    align-items: center;

    .fc-button-group {
      button {
        border-radius: 6px;
        border-width: 0;
      }
    }

    //.fc-button {
    //  &:hover {
    //    box-shadow:  0px 0px 4px 2px $coral;
    //  }

    .fc-button {
      &:hover {
        color: $coral;
        border-color: $coral;
        box-shadow: 0px 0px 1px 1px $coral;
      }
    }

    button {
      &:active,
      &:focus,
      &:hover {
        box-shadow: none;
      }

      &.fc-button-active {
        border-width: 1px;
      }
    }

    .fc-button-group {
      //border: 1px solid $medium-gray;
      border-radius: 6px;
      padding: 2px;

      .fc-button {
        &:focus {
          color: $white;
        }
      }
    }
  }

  .fc-toolbar-title {
    color: $dark-gray;
    display: inline-block;
    font-size: 16px;
    border: 1px solid $medium-gray;
    padding: 7px 10px;
    border-radius: 6px;
    line-height: 1.5;

    &:before {
      color: $coral;
      content: '\f073';
      font-family: 'Font Awesome 5 Pro';
      font-weight: 400;
      display: inline-block;
      margin-right: 5px;
    }
  }

  .event-type-select {
    min-width: 250px;

    //@include media-breakpoint-up(lg) {
    //  min-width: 200px;
    //}
  }
}
</style>
